import { render, staticRenderFns } from "./CuentaYFacturacion.vue?vue&type=template&id=b364a35e&scoped=true&"
import script from "./CuentaYFacturacion.vue?vue&type=script&lang=js&"
export * from "./CuentaYFacturacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b364a35e",
  null
  
)

export default component.exports